import {GsmCollectorDbReader, PaymentMessages} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public GsmCollectorDbReader: GsmCollectorDbReader,
    public PaymentMessages: PaymentMessages,
  ) {}
}